
export default function (Component) {
  Component.options.__source = "src/views/decisionBase/parametersLibrary/pmdSectionMaintenance.vue"
}
